/**
 * Shared sizing for the feedback and item-request forms (on `/feedback` and `/request-item`),
 * matched to the item detail sheet: compact on phones, a step up from `sm`.
 */
export const storeForm = {
  body: 'px-4 py-4 sm:px-8 sm:py-6',
  title: 'text-base font-semibold text-stone-900 sm:text-lg',
  intro: 'mt-0.5 text-xs text-stone-500 sm:text-sm',
  form: 'mt-4 space-y-4 sm:mt-6 sm:space-y-6',
  sectionLabel: 'text-xs font-semibold text-stone-800 sm:text-sm',
  fieldLabel: 'text-[11px] font-medium text-stone-600 sm:text-xs',
  input:
    'w-full rounded-lg border bg-white px-3 py-2 text-xs text-stone-800 outline-none placeholder:text-stone-400 focus:ring-2 focus:ring-primary-100 sm:text-sm',
  inputOk: 'border-stone-200 focus:border-primary-500',
  inputBad: 'border-red-300 focus:border-red-500',
  hint: 'text-[11px] text-stone-500 sm:text-xs',
  file:
    'max-w-full text-[11px] text-stone-600 file:mr-2 file:rounded-full file:border-0 file:bg-primary-50 file:px-3 file:py-1 file:text-xs file:font-medium file:text-primary-800 hover:file:bg-primary-100 sm:text-xs',
  error: 'rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-xs text-red-800 sm:text-sm',
  submit:
    'inline-flex h-11 w-full items-center justify-center rounded-full bg-primary-600 px-6 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-primary-700 active:bg-primary-800 disabled:cursor-not-allowed disabled:opacity-50 sm:w-auto sm:min-w-[180px]',
} as const
